var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutomatization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1905 13.3142V10.4611C15.7143 10.4611 11.9048 10.6133 11.4762 14.4554C12.9619 14.9784 13.7429 16.6142 13.219 18.0977C12.9655 18.8108 12.4392 19.3945 11.7554 19.7207C11.0717 20.0469 10.2863 20.0891 9.57143 19.8381C8.09524 19.3055 7.30476 17.6793 7.82857 16.1957C8.09524 15.3779 8.7619 14.7407 9.57143 14.4554C9.70464 12.8115 10.4665 11.282 11.699 10.1842C12.9314 9.08629 14.5398 8.50436 16.1905 8.5591V5.70607L20 9.51011L16.1905 13.3142ZM11.4286 17.1182C11.4286 16.866 11.3282 16.6241 11.1496 16.4457C10.971 16.2674 10.7288 16.1672 10.4762 16.1672C10.2236 16.1672 9.98136 16.2674 9.80276 16.4457C9.62415 16.6241 9.52381 16.866 9.52381 17.1182C9.52381 17.3704 9.62415 17.6123 9.80276 17.7907C9.98136 17.969 10.2236 18.0692 10.4762 18.0692C10.7288 18.0692 10.971 17.969 11.1496 17.7907C11.3282 17.6123 11.4286 17.3704 11.4286 17.1182ZM9.52381 9.62423C10.0762 8.99657 10.7143 8.45449 11.4286 8.01703V3.80405H14.2857L10.4762 0L6.66667 3.80405H9.52381V9.62423ZM4.95238 4.75506H3.04762L0 13.3142H1.80952L2.47619 11.4121H5.52381L6.19048 13.3142H8L4.95238 4.75506ZM2.90476 10.1283L4 6.65708L5.09524 10.1283H2.90476V10.1283Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatization);
export default __webpack_public_path__ + "static/media/automatization.3744607609de8b26d998ed13a45f2021.svg";
export { ForwardRef as ReactComponent };